export default __webpack_public_path__ + "static/media/plus.6ce7f475.svg";